import { nextTick, watch } from "vue";

export function useModalFocus(isOpen) {
    let trigger = null;

    watch(
        isOpen,
        (open) => {
            // Yeniden açılış kapanma animasyonunu keserse ilk açan öğeyi koru.
            if (open && !trigger && typeof document !== "undefined") trigger = document.activeElement;
        },
        { immediate: true }
    );

    async function restoreModalFocus() {
        // Headless UI 1.7 / Vue 3.5 odak dönüşü: https://github.com/tailwindlabs/headlessui/issues/3686
        // Arka planın inert durumu kalkınca, kapanış animasyonundan sonra geri dön.
        await nextTick();
        trigger?.focus({ preventScroll: true });
        trigger = null;
    }

    return { restoreModalFocus };
}
